import React, { useContext, useState } from 'react';
import ForgotPasswordForm from '../../Components/AdminDashboard/Adminauth/ForgotPasswordForm';
import CookiePreferences from '../../Components/AdminDashboard/Adminauth/CookiePreferences';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../../../src/pages/admin/admin_assets/css/ForgotPasswordPage.css';
import Logo from '../../../src/pages/admin/admin_assets/img/logo.svg';
import '../../../src/pages/admin/admin_assets/css/common.css';
import left_img from '../../../src/pages/admin/admin_assets/img/left_img.svg'; 
import { CopyrightContext } from '../../Components/CopyrightContext';


const ForgotPasswordPage = () => {
    const [showModal, setShowModal] = useState(false);

    const year = useContext(CopyrightContext)
    // const toggleModal = () => {
    //     setShowModal(!showModal);
    // };

    return (
        <div className="forgot-password-page">
            <div className="forgot-password-left">
                <div className="glass-layer glass-top">
                    <img src={Logo} alt="Logo" className="logo" />
                </div>
                <div className='left_img'>
                                <img src={left_img} alt='brew_left' />
                            </div>
                            <div className="glass-layer glass-bottom">
                                <span className="cookie-preferences"
                                //  onClick={toggleModal}
                                 >
                                    © {year} Brew Your Brand.
                                </span>
                            </div>
            </div>
            <div className="forgot-password-right">
                <div className="forgot-password-form-container">
                    <ForgotPasswordForm />
                </div>
            </div>
            {/* <CookiePreferences showModal={showModal} toggleModal={toggleModal} /> */}
        </div>
    );
};

export default ForgotPasswordPage;
